import { render } from "./CompareCriticalIllnessPolicyPage.vue?vue&type=template&id=bcc843d0&scoped=true"
import script from "./CompareCriticalIllnessPolicyPage.vue?vue&type=script&lang=js"
export * from "./CompareCriticalIllnessPolicyPage.vue?vue&type=script&lang=js"

import "./CompareCriticalIllnessPolicyPage.vue?vue&type=style&index=0&id=bcc843d0&lang=css"
import "./CompareCriticalIllnessPolicyPage.vue?vue&type=style&index=1&id=bcc843d0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcc843d0"]])

export default __exports__